import * as XLSX from "xlsx";

function download(filename, content, type) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function csvEscape(v) {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCSV(columns, rows) {
  const head = columns.map(csvEscape).join(",");
  const body = rows.map((r) => r.map(csvEscape).join(",")).join("\n");
  return `${head}\n${body}`;
}

export function downloadCSV(name, columns, rows) {
  download(`${name}.csv`, toCSV(columns, rows), "text/csv;charset=utf-8");
}

// Build every chart dataset from a report object.
export function getReportDatasets(b) {
  const ds = [];
  const L = b.lane, R = b.rates, RE = b.reliability, C = b.carriers, M = b.macro, T = b.thailand;

  ds.push({ name: "Far East TEU", columns: ["Month", "TEU"], rows: L.teu_labels.map((l, i) => [l, L.teu_far_east[i]]) });
  ds.push({ name: "Europe TEU", columns: ["Month", "TEU"], rows: L.teu_labels.map((l, i) => [l, L.teu_europe[i]]) });
  ds.push({ name: "Capacity growth by trade", columns: ["Trade", "YoY growth %"], rows: L.capacity_growth.map((d) => [d.trade, d.growth]) });
  ds.push({ name: "Small-ship orderbook", columns: ["Vessel size", "Ships ordered"], rows: T.orderbook.map((d) => [d.size, d.count]) });
  ds.push({ name: "SCFI Melbourne vs Europe", columns: ["Checkpoint", "Melbourne US$/TEU", "Europe US$/TEU"], rows: R.scfi_labels.map((l, i) => [l, R.scfi_melbourne[i], R.scfi_europe[i]]) });
  ds.push({ name: "Weekly rates", columns: ["Week", "Shanghai-Sydney", "Global Comprehensive", "Laem Chabang-Sydney"], rows: R.weekly_labels.map((l, i) => [l, R.weekly_shanghai[i], R.weekly_global[i], R.weekly_laem[i]]) });
  ds.push({ name: "Charter rate change", columns: ["Vessel size", "% change"], rows: R.charter.map((d) => [d.size, d.pct]) });
  ds.push({ name: "Reliability trend", columns: ["Period", "Headhaul %", "Backhaul %"], rows: RE.trend_labels.map((l, i) => [l, RE.trend_headhaul[i], RE.trend_backhaul[i]]) });
  ds.push({ name: "Carrier reliability", columns: ["Carrier", "Headhaul %", "Backhaul %", "Tracked arrivals"], rows: RE.carriers.map((d) => [d.carrier, d.headhaul, d.backhaul, d.arrivals]) });
  ds.push({ name: "Idle fleet", columns: ["Week", "Idle %"], rows: RE.idle_labels.map((l, i) => [l, RE.idle_values[i]]) });
  ds.push({ name: "Carrier market share", columns: ["Carrier", "Share %"], rows: C.market_share.map((d) => [d.name, d.value]) });
  ds.push({ name: "Hub port volumes", columns: ["Port", "1Q26 volume (M TEU)", "YoY %"], rows: C.hubs.map((d) => [d.port, d.volume, d.yoy]) });
  ds.push({ name: "Bunker prices", columns: ["Month", "Rotterdam $/t", "Singapore $/t", "Houston $/t"], rows: M.bunker_labels.map((l, i) => [l, M.bunker_rotterdam[i], M.bunker_singapore[i], M.bunker_houston[i]]) });
  return ds;
}

export function downloadExcel(b) {
  const wb = XLSX.utils.book_new();
  // Summary sheet
  const summaryRows = [["Asia–Australia Trade Briefing", b.period || ""], ["Title", b.meta?.title || ""], [], ["Executive summary"], [b.summary?.lede || ""], [], ["Key stats"]];
  (b.summary?.stats || []).forEach((s) => summaryRows.push([s.value, s.indicator, s.desc]));
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(summaryRows), "Summary");

  getReportDatasets(b).forEach((d) => {
    const aoa = [d.columns, ...d.rows];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    XLSX.utils.book_append_sheet(wb, ws, d.name.slice(0, 31));
  });
  XLSX.writeFile(wb, `Asia-Australia-Briefing_${(b.period || "report").replace(/\s+/g, "-")}.xlsx`);
}

// Native print-to-PDF helpers.
export function printFull(title) {
  const prev = document.title;
  document.title = title || prev;
  const restore = () => { document.title = prev; window.removeEventListener("afterprint", restore); };
  window.addEventListener("afterprint", restore);
  window.print();
}

export function printSummary(title) {
  const prev = document.title;
  document.title = title || prev;
  document.body.classList.add("print-summary");
  const restore = () => {
    document.body.classList.remove("print-summary");
    document.title = prev;
    window.removeEventListener("afterprint", restore);
  };
  window.addEventListener("afterprint", restore);
  window.print();
}
